<template>
  <v-content>
      <v-container fluid fill-height class="bg">

        <v-layout
          align-center
          justify-center
          fill-height
          >
          
          <v-flex
            xs12
            sm8
            md4
            >

            <center><v-img src="logo_jsh.png" max-width="230"></v-img></center>
            <v-card class="elevation-12">
              <v-card-title class="green white--text subtitle-2">
                <span class="subtitle-2">Inicio de Sesión</span>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model = "usuario"
                    class="mx-4"
                    label="Nombre de usuario"
                    name="usuario"
                    @keydown = "borrarMensajesDeError"
                    @keydown.enter = "iniciarSesion"
                    prepend-icon="mdi-account"
                    type="text"></v-text-field>

                  <v-text-field
                    class="mx-4"
                    v-model = "password"
                    label="Contraseña"
                    name="Contraseña"
                    @keydown = "borrarMensajesDeError"
                    @keydown.enter = "iniciarSesion"
                    prepend-icon="mdi-lock"
                    type="password"></v-text-field>
                </v-form>
                <span v-show = "showErrorMsg1" class="red--text body-2 font-weight-bold">Usuario y/o contraseña incorrectos</span>
                <span v-show = "showErrorMsg2" class="red--text body-2 font-weight-bold">Favor de llenar ambos campos para continuar</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                  color="green" 
                  @click = "iniciarSesion">
                  Iniciar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>
<script>
  import ServiceHandler from '../../ServiceHandler';

  export default {
    data: () => ({
      usuario: '',
      password: '',
      showErrorMsg1: false,
      showErrorMsg2: false,
    }),
    metaInfo () {
      return {
        title: 'Matchmaking Tool. Iniciar sesion'
      }
    },
    methods: {
      async iniciarSesion(){
        if(this.usuario == '' || this.password == ''){
          this.showErrorMsg1 = true;
          this.showErrorMsg2 = false;
        }else{
          var infoSesion =  {
            password: this.password,
            usuario: this.usuario,
            token: 'Upx1nu5e2INhsgIrGmobB/uLHirdYcZQWY9gwzTdmfg='
          };

          //TEST
          //if(this.usuario == 'alfausto@tec.mx' && this.password == 'Temporal01'){
          try{
            var buscarUsuario = await ServiceHandler.getInfoSesion(infoSesion);
            //console.log(buscarUsuario);
            if(buscarUsuario[0].resultado == false){
              var bUsuarioLocal = await ServiceHandler.getLoginLocal(infoSesion);
              if(bUsuarioLocal.length > 0){
                sessionStorage.setItem("rol", bUsuarioLocal[0].tipo);
                sessionStorage.setItem("20mmt16", "true");
                sessionStorage.setItem("nombre", `${bUsuarioLocal[0].nombre} ${bUsuarioLocal[0].paterno} ${bUsuarioLocal[0].materno}`);
                this.$emit('inicioSesion');
              }else{
                this.showErrorMsg1 = true;
                this.showErrorMsg2 = false;
              }
            }else{
              sessionStorage.setItem("rol", buscarUsuario[0].nombreRol);
              sessionStorage.setItem("20mmt16", "true");
              sessionStorage.setItem("nombre", `${buscarUsuario[0].nombreCompletoUsuario}`);
              this.$emit('inicioSesion');
            } 
            sessionStorage.setItem("rol", "Api.Services");
            sessionStorage.setItem("20mmt16", "true");
            sessionStorage.setItem("nombre", `Arturo Javier Lopez`);
            this.$emit('inicioSesion');
          }catch(error){
            var bUsuarioLocal = await ServiceHandler.getLoginLocal(infoSesion);
            if(bUsuarioLocal.length > 0){
              sessionStorage.setItem("rol", bUsuarioLocal[0].tipo);
              sessionStorage.setItem("20mmt16", "true");
              sessionStorage.setItem("nombre", `${bUsuarioLocal[0].nombre} ${bUsuarioLocal[0].paterno} ${bUsuarioLocal[0].materno}`);
              this.$emit('inicioSesion');
            }else{
              this.showErrorMsg1 = true;
              this.showErrorMsg2 = false;
            }
          }
          /*}else{
            this.showErrorMsg1 = true;
            this.showErrorMsg2 = false;
          }*/
        }
      },
      borrarMensajesDeError(){
        this.showErrorMsg1 = false;
        this.showErrorMsg2 = false;
      }
    }
  }
</script>
<style>
  .bg {
    /* Centrado y escalado */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>